import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";

export const getFaqListApiCall = createAsyncThunk("faqList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: faqList } = await API.getFaqListApi(submitData);
        //console.log("data----------------",faqList);
        
        dispatch(setLoader(false))
        return faqList;
    } catch (error) {
        throw error;
    }
});

export const editFaqDataApiCall = createAsyncThunk("editFaqData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editFaqData, code, message } = await API.editFaqApi(submitData);
        if (code === '1') {
           // TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editFaqData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    faqList: {
        data: [],
        error: null,
    },
    editFaqData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const faqSlice = createSlice({
    name: "FAQ",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFaqListApiCall.fulfilled, (state, action) => {
                state.faqList.data = action.payload;
            })
            .addCase(getFaqListApiCall.rejected, (state, action) => {
                state.faqList.error = action.error.message;
            })
            .addCase(editFaqDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editFaqData.data = data;
                state.editFaqData.message = message;
                state.editFaqData.code = code;
            })
            .addCase(editFaqDataApiCall.rejected, (state, action) => {
                state.editFaqData.error = action.error.message;
            });
    },
});

export default faqSlice.reducer;